import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { message, notification } from 'antd';
import { SecuredKoppClient } from '../Api/Kopp/SecuredKoppClient';
import { withRouter, StaticRouter } from 'react-router-dom';
import ConfigUtility from '../ConfigUtility';
import LoaderUtility from '../LoaderUtility/LoaderUtility'

import TokenUtility from '../TokenUtility';
import React, { Fragment } from 'react';

import { ExtendedAxios, ErrorDetails } from './SecuredAxios';
import NotificationUtility from 'Core/NotificationUtility';
import { uniqueId, random } from 'lodash';
import Utility from 'Core/Utility';

const getSecuredUMATokenAxiosInstance: () => ExtendedAxios = () => {
  let SecuredUMATokenAxios: ExtendedAxios = Object.assign(
    {
      disableToken: false,
      handleSecurityError: true,
      ShowLoader: config => { },
      HideLoader: config => { },
      GetErrorDetails: () => { },
      baseUrlConfigName: '',
    },
    axios.create({
      timeout: 30000,
    })
  );

  SecuredUMATokenAxios.interceptors.request.use(
    async config => {
      // turning on loader
      SecuredUMATokenAxios.ShowLoader(config);
      const appConfig = await ConfigUtility.get();
      config.baseURL = appConfig[SecuredUMATokenAxios.baseUrlConfigName!];

      // Add Correlation ID header
      config.headers[appConfig.CorrelationIdHeader] = Utility.GetOrGenerateCorrleationId();
      config.headers[appConfig["SessionIdHeader"] ?? "SessionId"] = TokenUtility.GetSessionId();

      const umaTokenExpirationDate = TokenUtility.GetUMATokenExpirationDate();
      if (umaTokenExpirationDate && umaTokenExpirationDate.isBefore()) {
        // Need to get a new token
        const client = new SecuredKoppClient();
        client.showLoading = false;
        client.handleGeneralError = false;
        client.handleSecurityError = false;
        try {
          // This will update the cookie that has the token
          const response = await client.refreshUMAToken();
        } catch (error) { }
      }

      if (!SecuredUMATokenAxios.disableToken) {
        const umaToken = TokenUtility.GetUMAToken();
        // Add header if exist
        config.headers.Authorization = 'Bearer ' + umaToken;
      }

      return config;
    },
    error => {
      // Do something with error
      return Promise.reject(error);
    }
  );

  SecuredUMATokenAxios.interceptors.response.use(
    response => {
      SecuredUMATokenAxios.HideLoader(response.config);
      return response;
    },
    (error: { config: AxiosRequestConfig; response: AxiosResponse }) => {
      HideAllLoaders();
      HandleSecurityErrors(error);
      HandleErrors(error);
      return Promise.reject(error);
    }
  );

  function HideAllLoaders() {
    if (SecuredUMATokenAxios.showLoading) {
      message.destroy();
    }
  }

  function HandleSecurityErrors(error: {
    config: AxiosRequestConfig;
    response: AxiosResponse<any>;
  }) {
    if (SecuredUMATokenAxios.handleSecurityError) {
      const errorDetails = SecuredUMATokenAxios.GetErrorDetails(error);
      if (errorDetails.statusCode === 403) {
        NotificationUtility.error('You do not have permission to access that operation. You can try logining with credentials that do.', '', 0, true);

      }
      if (errorDetails.statusCode === 401) {
        NotificationUtility.error('You were inactive for a long time and need to login again. Please login to continue', '', 0, true);
      }
    }
  }

  function HandleErrors(error: { config: AxiosRequestConfig; response: AxiosResponse<any> }) {
    if (SecuredUMATokenAxios.handleGeneralError) {
      const errorDetails = SecuredUMATokenAxios.GetErrorDetails(error);

      switch (errorDetails.statusCode) {
        case 400:
          NotificationUtility.error(errorDetails.message, '', 0, true);
          break;

        case 800:
          NotificationUtility.error('Had a problem making that last request, please ensure you are connected to the internet.', '', 0, true);
          break;

        case 403:
        case 401:
          // It is a security error and will be handled somewhere else
          break;

        default:
          NotificationUtility.error('Oops...Something Went Wrong',
            (
              <>
                <p>
                  Somthing happend on that last request. Please contact administrator with this
                  error code:
                </p>
                <p>{errorDetails.eventMarker}</p>
              </>
            ),
            0, true);
          break;
      }
    }
  }

  SecuredUMATokenAxios.GetErrorDetails = function (error: any) {
    return (error.response || { data: { statusCode: 800, eventMarker: '1111-1111-1111-1111' } })
      .data as ErrorDetails; // here we handle the senario if the issue is client side and we don't get back the response object
  };

  SecuredUMATokenAxios.HideLoader = function (config: any) {
    LoaderUtility.hide()
  };


  SecuredUMATokenAxios.ShowLoader = function ShowLoader(config: any) {
    LoaderUtility.show();
  };

  return SecuredUMATokenAxios;
};

export default getSecuredUMATokenAxiosInstance;
